import { render, staticRenderFns } from "./EditorSnackbar.vue?vue&type=template&id=678c1b40&scoped=true"
import script from "./EditorSnackbar.vue?vue&type=script&lang=js"
export * from "./EditorSnackbar.vue?vue&type=script&lang=js"
import style0 from "./EditorSnackbar.vue?vue&type=style&index=0&id=678c1b40&prod&scoped=true&lang=css"
import style1 from "./EditorSnackbar.vue?vue&type=style&index=1&id=678c1b40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c1b40",
  null
  
)

export default component.exports